import script from "./ExportHistoryModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportHistoryModal.vue?vue&type=script&lang=ts&setup=true"

import "./ExportHistoryModal.vue?vue&type=style&index=0&id=60de026c&lang=scss"

const __exports__ = script;

export default __exports__